export const MARKETPLACE_PROVISIONED_APPS_FETCH =
  "MARKETPLACE_PROVISIONED_APPS_FETCH";
export const MARKETPLACE_PROVISIONED_APPS_RECEIVE =
  "MARKETPLACE_PROVISIONED_APPS_RECEIVE";
export const MARKETPLACE_PROVISIONED_APPS_FAILURE =
  "MARKETPLACE_PROVISIONED_APPS_FAILURE";
export const MARKETPLACE_PROVISIONED_APPS_TOGGLE_VIEWMORE =
  "MARKETPLACE_PROVISIONED_APPS_TOGGLE_VIEWMORE";
export const MARKETPLACE_PROVISIONED_APPS_TOGGLE_HIDDEN_REGION =
  "MARKETPLACE_PROVISIONED_APPS_TOGGLE_HIDDEN_REGION";
export const MARKETPLACE_PROVISIONED_APPS_NEXT_PAGE =
  "MARKETPLACE_PROVISIONED_APPS_NEXT_PAGE";
export const MARKETPLACE_PROVISIONED_APPS_FIRST_PAGE =
  "MARKETPLACE_PROVISIONED_APPS_FIRST_PAGE";
export const MARKETPLACE_PROVISIONED_APP_DELETE_STARTED =
  "MARKETPLACE_PROVISIONED_APP_DELETE_STARTED";
export const MARKETPLACE_PROVISIONED_APP_DELETE_FAILED =
  "MARKETPLACE_PROVISIONED_APP_DELETE_FAILED";
export const MARKETPLACE_PROVISIONED_APP_DELETE_SUCCESS =
  "MARKETPLACE_PROVISIONED_APP_DELETE_SUCCESS";
